<template lang="pug">
  .profile
    header.profile-header
      .profile-content(@click="goToProfilePage")
        UserAvatar.profile-avatar(v-bind="user")
        .profile-name {{ user.name }}
        .profile-details
          span.profile-details-jobTitle {{ jobTitle }}
          span &nbsp;-&nbsp;
          span.profile-details-code {{ user.employeeCode }}
</template>

<script>
import UserAvatar from './UserAvatar'
import { mapState } from 'vuex'

export default {
  components: { UserAvatar },
  computed: {
    ...mapState({
      user: state => ({
        ...state.auth.user,
        ...state.layout.user,
        pointsGame: state.score.data?.total || 0,
        pointsPerformance: state.performance.data?.total || 0,
      }),
    }),
    isConsultant() {
      const { consultantFor, jobTitle, isConsultantManager } = this.user
      return (
        (!!consultantFor?.length || isConsultantManager) &&
        jobTitle === 'Empresa'
      )
    },
    fullUser() {
      return this.$store.state.layout.user
    },
    isConsultantManager() {
      return this.user.isConsultantManager
    },
    jobTitle() {
      if (this.isConsultantManager) return 'Gerente Consultor'
      if (this.isConsultant) return 'Consultor'
      return this.user.jobTitle
    },
  },
  methods: {
    goToProfilePage() {
      this.$router.push('/perfil')
    },
  },
}
</script>

<style lang="sass" scoped>
.profile
  &-header
    min-height: 152px
    background: #232378
      image: url(/images/profile-background.svg)
      position: -100% 10%
    color: white
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    padding: 12px 16px
    text-shadow: 1px 1px 3px rgba(0,0,0,.3)
  &-content
    display: flex
    flex-direction: column
    align-items: center
  &-avatar
    height: 72px
    width: 72px
    margin-bottom: 6px
  &-name
    font-size: 1.2em
    margin: 6px 0
    font-weight: bold
    text-align: center
  &-details
    font-size: 0.9em
</style>
